exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pkg-no-file{display:flex;justify-content:center;align-items:center;height:calc(100% - 57px);color:green}.pkg-no-file .pkg-empty-title{margin-top:-15px;font-size:14px;color:#237bf8;text-align:center}#different-password-confirm,#download-client-confirm{z-index:99}", ""]);

// exports
